import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const Batteries: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Redireciona para o catálogo de baterias preservando os query params
    navigate(`/catalogo${location.search}`, { replace: true })
  }, [navigate, location.search])

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">Redirecionando para o catálogo de baterias...</p>
      </div>
    </div>
  )
}

export default Batteries
